import { Card, Form, Upload } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import UploadImage from "../common/UploadImage";
import TopHeading from "./TopHeading";
import { authenticateToken } from "../../utils/auth";
import axios from "axios";
import { CopyOutlined } from "@ant-design/icons";
import { useForm } from "react-hook-form";
import { getImgUrl } from "../../utils/index";

interface FileType {
  originFileObj: any;
  uid: string;
  name: string;
  status: string;
  url: string;
}

const FileManager = () => {
  const [fileList, setFileList] = useState<FileType[]>([]);
  const [data, setData] = useState({ loading: false, item: undefined });
  const [generatedUrl, setGeneratedUrl] = useState();

  const textRef = useRef(null);

  const [form] = Form.useForm();

  const onChange = ({ fileList: newFileList }: any) => {
    setFileList(newFileList);
  };

  const onPreview = async (file: any) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  const uploadImage = async () => {
    const formData = new FormData();
    formData.append("frontImage", fileList?.[0]?.originFileObj);
    formData.append("documentType", "static_image");

    await fetch(`${process.env.REACT_APP_RIDER_API}/admin/document/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authenticateToken()}`,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        setGeneratedUrl(res.url);
        setFileList([]);
        form.resetFields();
      })
      .catch((err) => {
        console.error("err", err);
      });
  };

  return (
    <React.Fragment>
      <TopHeading {...0} />
      <section className="bg-white rounded p-2">
        <Card>
          <div className="d-flex justify-content-between">
            <div className="">
              <Form form={form}>
                <Form.Item name="image">
                  <Upload
                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                    listType="picture-card"
                    onChange={onChange}
                    onPreview={onPreview}
                  >
                    {fileList.length < 1 && "+ Upload"}
                  </Upload>
                </Form.Item>
              </Form>
            </div>
            {generatedUrl && (
              <div className="mb-4 d-flex ml-4">
                <button
                  className="btn btn-sm btn-danger mr-3"
                  onClick={() => {
                    navigator.clipboard.writeText(textRef?.current?.innerText);
                  }}
                >
                  <CopyOutlined title="Copy" />
                </button>
                <div className="d-flex d-flex-l d-flex-nowrap">
                  <img
                    src={getImgUrl(generatedUrl)}
                    alt=""
                    className="mr-2"
                    height={80}
                    width={80}
                    style={{ height: 80, width: 80, boxShadow: '0 5px 10px 1px rgba(196, 192, 195, .3)' }}
                  />
                  <small ref={textRef}>{generatedUrl}</small>
                </div>
              </div>
            )}
          </div>

          <button
            onClick={() => uploadImage()}
            disabled={!fileList.length}
            className="btn btn-primary px-5 btn-sm"
          >
            Upload
          </button>
        </Card>
      </section>
    </React.Fragment>
  );
};

export default FileManager;
